/* global axios */
import ApiClient from './ApiClient';

class FlowsAPI extends ApiClient {
  constructor() {
    super('flows', { accountScoped: true });
  }

  clone(flowId) {
    return axios.post(`${this.url}/${flowId}/clone`);
  }

  stats(flowId) {
    return axios.get(`${this.url}/${flowId}/stats`);
  }
}

export default new FlowsAPI();
